import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import talentProfileApi from '../../../../services/talentProfiles';
import { CURRENT_YEAR } from '../../../../utils/constants';
import styles from './historical-talent-status-print.module.scss';
import { TP_PRINT_SECTION_NAME } from '../../constants';
import { updatePrintData } from '../../../../pages/TalentProfilePage/store/printProfileSlice';

const HistoricalTalentStatusPrint = (props) => {
  const { profileId, fetchedData, tokenTalentProfile } = props;
  const user = useSelector((state) => state.user);
  const [historical, setHistorical] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    async function fetchApi() {
      if (!user.roleActive) return;
      try {
        const response = await talentProfileApi.fetchHistoricalTalentStatus({
          profileId,
          roleUser: user,
          tokenTalentProfile,
        });
        if (response.status === 200) {
          const newArr = [];
          response.data.result.forEach((item) => {
            if (!item.platform === false || !item.start_date === false || !item.end_date === false || !item.status === false) {
              newArr.push(item);
            }
          });
          dispatch(
            updatePrintData({
              sectionName: TP_PRINT_SECTION_NAME.HISTORICAL_TALENT_STATUS,
              data: newArr,
            })
          );
        }
      } catch (error) {
        setHistorical([]);
      }
    }
    if (fetchedData) {
      setHistorical(fetchedData);
      return;
    }
    fetchApi();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user.roleActive.roleId, profileId, fetchedData]);

  return (
    <div className={styles.SectionPlan} data-testid="historical-talent" data-print-section={TP_PRINT_SECTION_NAME.HISTORICAL_TALENT_STATUS}>
      <div className={styles.SectionName}>Historical Talent Status</div>
      <div className={styles.tablePlan}>
        <table className="table">
          <thead>
            <tr className={styles.tablePlanThead}>
              <th scope="col">Status</th>
              <th scope="col">Start Date</th>
              <th scope="col">End Date</th>
              <th scope="col">Platform</th>
            </tr>
          </thead>
          <tbody>
            {!!historical &&
              historical.length > 0 &&
              historical?.map((data, index) => (
                <tr data-testid="list-historical" key={index} className={styles.tablePlanBody}>
                  <td data-testid="talent-status" className={styles.tablePlanBodyStatus}>
                    {!data.status ? '-' : data.status}
                  </td>
                  <td data-testid="talent-start-date">
                    {moment(data.start_date).format('D MMMM YYYY') !== 'Invalid date' ? moment(data.start_date).format('D MMMM YYYY') : '-'}
                  </td>
                  <td data-testid="talent-end-date">
                    {moment(data.end_date).format('D MMMM YYYY') !== 'Invalid date' && !data.end_date.includes(CURRENT_YEAR)
                      ? moment(data.end_date).format('D MMMM YYYY')
                      : '-'}
                  </td>
                  <td data-testid="talent-platform">{!data.platform ? '-' : data.platform}</td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default HistoricalTalentStatusPrint;
